import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

import * as _ from 'lodash';

import { AuthService } from './../../services/auth.service';
import { MemberService } from './../../rest/api/member.service';
import { HelperService } from './../../services/helper.service';
import { SpaceService } from './../../services/space.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  accessToken: any;

  spaceCategoryData: any;
  spaceListData: any;
  spaceLoader = true;
  companyData: any;
  currentCompany: any;

  totalCount: number;
  itemsPerPage = 5;
  currentPage = 1;

  categoryId = '';
  keywords = '';

  isSearched = false;

  langShortCode: any;

  createSpaceClicked = false;

  subscriptionStatus: any;

  companyNotFound: any;

  constructor(
    private authService: AuthService,
    public memberService: MemberService,
    public helperService: HelperService,
    public spaceService: SpaceService,
    private router: Router
  ) {
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
    this.langShortCode = localStorage.getItem('language') ? localStorage.getItem('language') : undefined;

    this.subscriptionStatus = this.authService.getSubscriptionStatus();

  }

  ngOnInit() {
    this.spaceService.companyDataSubscription.subscribe(response => {
      this.companyData = response;
      if (this.companyData && this.companyData.length > 0) {
        this.currentCompany = _.find(this.companyData, {selected: true});
        this.getSpaceCategory();
        this.getSpaceList(1, this.itemsPerPage, '', '');
      } else {
        this.spaceLoader = false;
        this.companyNotFound = true;
        setTimeout(() => {
          this.authService.logout();
          this.router.navigate(['/register']);
        }, 2000);
      }
    }, err => {
      this.companyData = [];
    });
  }

  getSpaceCategory() {
    if (this.langShortCode) {
      this.memberService.getSpaceCategory({
        Authorization: this.accessToken,
        lang: this.langShortCode
      }).subscribe((response: any) => {
        this.spaceCategoryData = response && response.data ? response.data : [];
      }, err => {
        this.spaceCategoryData = [];
      });
    } else {
      this.memberService.getSpaceCategory({
        Authorization: this.accessToken
      }).subscribe((response: any) => {
        this.spaceCategoryData = response && response.data ? response.data : [];
      }, err => {
        this.spaceCategoryData = [];
      });
    }
  }

  getSpaceList(page, limit, categoryId, keywords) {

    const thisobject = this;
    this.memberService.getMemberSpace({
      Authorization: this.accessToken,
      page: page,
      paginate: limit,
      categoryId: categoryId || undefined,
      keywords: keywords || undefined,
      status: ''
    }).subscribe((response: any) => {
      thisobject.totalCount = response.meta && response.meta.pagination && response.meta.pagination.total
      ? response.meta.pagination.total : 0;
      thisobject.spaceListData = response && response.data ? response.data : [];
      thisobject.spaceLoader = false;
    }, err => {
      thisobject.spaceListData = [];
      thisobject.spaceLoader = false;
    });
  }

  pageChanged(event) {
    this.spaceLoader = true;
    this.currentPage = event;
    this.getSpaceList(event, this.itemsPerPage, this.categoryId, this.keywords);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  createSpaceEmit(response) {
    this.categoryId = '';
    this.keywords = '';
    this.pageChanged(1);
  }

  searchSpaces() {
    this.isSearched = true;
    this.pageChanged(1);
  }

  deleteMemberSpaceEmit(event) {
    this.categoryId = '';
    this.keywords = '';
    this.isSearched = false;
    if (this.spaceListData.length === 1 && this.currentPage > 1) {
      this.currentPage = this.currentPage - 1;
      this.pageChanged(this.currentPage);
    } else {
      this.pageChanged(this.currentPage);
    }
  }

  createSpace() {
    this.createSpaceClicked = true;
  }

  changeCompany(companyId) {
    const company = _.find(this.companyData, {company_id: companyId});
    if (company) {
      this.currentCompany = company;
      // Setting roles and company id
      this.authService.setCompanyId(company.company_id);
      this.authService.setCompanyRoles(company.role);
      this.authService.setInvoiceAccess(company.invoice_permission);
      this.authService.setBillingAccess(company.billing_permission);
      this.companyData = _.map(this.companyData, (res) => {
        if (res.company_id === company.company_id) {
          res.selected = true;
        } else {
          res.selected = false;
        }
        return res;
      });
      this.spaceService.setCompanyData(this.companyData);
      this.spaceLoader = true;
      this.getSpaceList(1, this.itemsPerPage, '', '');
    }
  }

}
